export default [
    {
        name: 'Translate',
        icon: 'fad fa-arrows-alt',
        description:
            'Click and drag the geo record to update geo records location.',
    },
    {
        name: 'Rotate',
        icon: 'fas fa-sync-alt',
        description: 'Click and rotate the geo records.',
    },
];
